import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
} from "@mui/material";

/**
 * Confirms cancelling a running batch. Destructive and not undoable — it stops the
 * batch's Fargate tasks, so a company mid-classification is killed partway and gets
 * no sheet. Spell that out rather than asking a bare "are you sure?".
 */
function CancelRunDialog({ open, onClose, onConfirm, batchRunId, companyCount }) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Cancel pipeline run?</DialogTitle>
      <DialogContent>
        <Divider sx={{ mb: 2 }} />
        <Typography variant="body1">
          This stops the running geocoder and auto4client tasks for this batch. Companies
          part-way through classification are killed and will not get a sheet — data already
          written to the database stays, but is incomplete for those companies.
        </Typography>
        <Typography variant="body2" sx={{ mt: 2, color: "text.secondary" }}>
          {companyCount} {companyCount === 1 ? "company" : "companies"} in this batch.
        </Typography>
        <Typography
          variant="body2"
          sx={{ mt: 1, color: "text.secondary", wordBreak: "break-all" }}
        >
          {batchRunId}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Keep running</Button>
        <Button color="error" onClick={onConfirm}>
          Cancel run
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default CancelRunDialog;
